export function useTheme() {
  const layoutStore = useLayoutStore();

  // In mixin, beforeMount set attribute.
  // In composable, we can do it in onMounted or expose a setup function.

  const initTheme = () => {
    const theme = layoutStore.theme || "light";
    if (import.meta.client) {
      document.documentElement.setAttribute("data-theme", theme);
    }

    watch(
      () => layoutStore.theme,
      (newTheme) => {
        if (import.meta.client) {
          document.documentElement.setAttribute(
            "data-theme",
            newTheme || "light",
          );
        }
      },
    );
  };

  return {
    initTheme,
  };
}
